import { render, staticRenderFns } from "./WapMyTestRecord.vue?vue&type=template&id=297c706b&"
import script from "./WapMyTestRecord.vue?vue&type=script&lang=js&"
export * from "./WapMyTestRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports